import type { SupportedDevicesMap } from "./supportedDevices.types";

let cachedDevices: SupportedDevicesMap | null = null;
let loadPromise: Promise<SupportedDevicesMap> | null = null;

/**
 * 预加载设备配置表（主应用入口在 render 前 await，行为与原先 sync import 一致）。
 */
export async function ensureSupportedDevices(): Promise<SupportedDevicesMap> {
  if (cachedDevices) {
    return cachedDevices;
  }
  if (!loadPromise) {
    loadPromise = import(
      /* webpackChunkName: "supported-devices" */
      "./supportedDevices.data"
    ).then((mod) => {
      cachedDevices = mod.SUPPORTED_DEVICES;
      return cachedDevices;
    });
  }
  return loadPromise;
}

function loadSupportedDevicesFromDataModule(): SupportedDevicesMap {
  // 模块顶层 IIFE（如 keyboardDeviceMatch）可能在 ensure 完成前读取；与 async chunk 为同一份数据
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const mod = require("./supportedDevices.data") as {
    SUPPORTED_DEVICES: SupportedDevicesMap;
  };
  return mod.SUPPORTED_DEVICES;
}

/** 在 ensureSupportedDevices 完成后同步读取（与历史 SUPPORTED_DEVICES 用法一致） */
export function getSupportedDevicesSync(): SupportedDevicesMap {
  if (!cachedDevices) {
    cachedDevices = loadSupportedDevicesFromDataModule();
  }
  return cachedDevices;
}
